<template>
  <div>
    <div class="info-area">
      <div class="operational-title">
        <h3 class="info-title">
          {{ agentTool.name ? agentTool.name : '' }}
        </h3>
      </div>
      <div class="info-inline">
        <div class="info-item">类型：{{ agentTool.type || '--' }}</div>
      </div>
      <div class="info-inline">
        <p>备注描述： {{ agentTool.description }}</p>
      </div>
    </div>
    <div class="param-area">
      <div class="param-table-box">
        <h3 class="info-title">输入参数</h3>
        <params-json-schema-view
          :json-schema="agentTool.inputs"
        />
      </div>
      <div class="param-table-box">
        <h3 class="info-title">输出参数</h3>
        <params-json-schema-view
          :json-schema="agentTool.outputs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ParamsJsonSchemaView from './components/paramsJsonSchemaView.vue';
export default {
  components: {ParamsJsonSchemaView},
  data() {
    return {
      agentTool: {},
    };
  },
  async mounted() {
    this.getAgentTool();
  },
  methods: {
    async getAgentTool() {
      const { agent_tool: agentTool } = await this.$request({
        data: {
          id: this.$route.query.id,
          is_system: this.$route.query.is_system === true || this.$route.query.is_system === 'true',
        },
        url: this.$api.getAgentTool,
      });
      this.agentTool = agentTool;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-area {
  background-color: #fff;
  color: rgba(56, 64, 80, 1);
  font-size: 14px;
  margin-bottom: 12px;
  padding: 12px 12px 12px 12px;
  .operational-title {
    display: flex;
    justify-content: space-between;
    .info-title {
      font-weight: 700;
      font-size: 16px;
    }
    .operational-button {
      height: 40px;
    }
  }
  .info-inline {
    display: flex;
    .info-item {
      width: 25%;
    }
  }
}
.param-area {
  display: flex;
  margin-bottom: 12px;
  .param-table-box {
    padding: 12px 12px 12px 12px;
    width: calc((100% - 12px) / 2);
    background-color: #fff;
    &:first-child {
      margin-right: 12px;
    }
  }
}
.ide-area {
  display: flex;
  width: 100%;
  height: 600px;
  margin-bottom: 12px;
  .file-tree {
    width: 300px;
    height: 100%;
  }
  #code-editor {
    width: 100%;
    height: 100%;
  }
}
</style>
